// extracted by mini-css-extract-plugin
module.exports = {"label_wrapper":"dece2e673c--label_wrapper--2whQ4"};